module.exports = __webpack_public_path__ + "img/illustrations/drag-to-reposition-7ec1ee61b9df6b7e9794c36aeeb1e97d.svg";